import http from "../request/index";

export default {
  async loginByWx(params) {
    return await http.get(
      "https://zsrbactivity.zsnews.cn/api/common/wechatoath",
      params
    );
  },

  async getZsplusJsBrigde() {
    return await http.get(
      "https://zsrbactivity.zsnews.cn/api/common/zsrbjsbrigeconfig"
    );
  },
  async readNewsAddPoint(data) {
    return await http.post("/mobile/news/readNewsAddPoint", data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  // 投票详情页面中不需要传unionId
  async getVotes({ id }) {
    return await http.get(
      `https://zsplus-fastapi.zsnews.cn/api/plus/votes/${id}`
    );
  },

  async voting({ id, data }) {
    return await http.put(
      `https://zsplus-fastapi.zsnews.cn/api/plus/votes/${id}/voting`,
      data,
      {}
    );
  },

  //通过活动用户登录中山+
  async getByActivity(params) {
    return await http.post(
      "https://zsplus-fastapi.zsnews.cn/api/plus/auth/wechat/h5",
      params
    );
  },
  //发表评论
  async postComment(params) {
    console.log("postComment", params);
    return await http.post(
      "https://zsplus-fastapi.zsnews.cn/api/plus/comment",
      params
    );
  },
  //点赞评论
  async postLike(id) {
    return await http.post(
      `https://zsplus-fastapi.zsnews.cn/api/plus/comment/${id}/like`,
      {}
    );
  },
  //  评论列表
  async getCommentList(params) {
    return await http.get(
      "https://zsplus-fastapi.zsnews.cn/api/plus/comment/list-for-info/v2/" +
        params.id,
      {
        page: params.page,
        page_size: params.page_size
      }
    );
  },
  // 排行榜列表
  async getItemCommentRanking(params) {
    return await http.get(
      "https://zsplus-fastapi.zsnews.cn/api/plus/comment-ranking",
      params
    );
  },
  // 我的评论主页（从“我的”页面进入）
  async getMyCommentList(params) {
    return await http.get(
      "https://zsplus-fastapi.zsnews.cn/api/plus/comment/my-home-page",
      params
    );
  },
  // 评论主页（从评论列表页进入）
  async getHomepageCommentList(params) {
    return await http.get(
      "https://zsplus-fastapi.zsnews.cn/api/plus/user/home-page",
      params
    );
  },
  // 修改个人简介
  async updatePersonalProfile(params) {
    return await http.post(
      "https://zsplus-fastapi.zsnews.cn/api/plus/user/update-personal-profile",
      params
    );
  },
  //点赞文章
  async postLikeArticle(id) {
    return await http.post(
      `https://zsplus-fastapi.zsnews.cn/api/plus/infos/${id}/like`,
      {}
    );
  },
  async getInfoExtend(id) {
    return await http.get(
      `https://zsplus-fastapi.zsnews.cn/api/plus/infos/${id}/extend`,
      {}
    );
  },
  //  viewinfo桥接信息
  async getViewInfoBridging(id) {
    return await http.get(
      `https://zsplus-fastapi.zsnews.cn/api/plus/infos/${id}/view-info-bridging`
    );
  },
  async ReadingNews(params) {
    return await http.post(
      `https://zsplus-fastapi.zsnews.cn/api/plus/welfare-task/finish`,
      params
    );
  },
  async getByPreviewAuth(params) {
    return await http.post(
      `https://zsplus-fastapi.zsnews.cn/api/plus/auth/wechat/h5/preview/${params.previewId}`,
      { params }
    );
  },
  async getArticle(id) {
    return await http.get("/api/news-detail/normal/" + id);
  },
  async getPreArticle(id) {
    return await http.get("/api/news-detail/preNormal/" + id);
  },
  async getReporterList(id) {
    return await http.get(
      "/api-v2/api/find-reporter/reporters/list-for-info/" + id
    );
  },
  async getRelateList(id) {
    return await http.get(
      "/api-v2/api/information/news/relate-list-for-info/" + id
    );
  },
  async getInfoListPreview(params) {
    return await http.get(
      "https://zsplus-fastapi.zsnews.cn/api/plus/comment/list-for-info-preview/" +
        params.id,
      {
        page: params.page,
        page_size: params.page_size
      }
    );
  }
};
